/**
 * Array of panel names rendered in the page component.
 * @public
 */
export const pagePanels = ['sidebar', 'main', 'details'] as const;

/**
 * Panels rendered in the page component.
 * @public
 */
export type PagePanels = (typeof pagePanels)[number];

/**
 * Page panels that can be dismissed.
 * @public
 */
export type DismissiblePagePanels = Extract<PagePanels, 'sidebar' | 'details'>;

/**
 * Object holding the current widths of the panels rendered in the page.
 * @internal
 */
export type SlotWidths = {
  [key in PagePanels]?: number;
};

/**
 * Current size of each page panel in different units.
 * @public
 */
export type PagePanelSizes = Record<
  PagePanels,
  { [key in 'px' | '%']: number }
>;

/**
 * @public
 */
export type ControlledPagePanelProps = {
  /** If the panel is opened. */
  dismissed: boolean;
  /** If the panel is dismissed by default. */
  defaultDismissed?: never;
};

/**
 * @public
 */
export type UncontrolledPagePanelProps = {
  /** If the panel is opened. */
  dismissed?: never;
  /** If the panel is dismissed by default. */
  defaultDismissed?: boolean;
};

/**
 * @public
 */
export type PagePanelProps =
  | ControlledPagePanelProps
  | UncontrolledPagePanelProps;
